var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.767,
    height: 10.671,
    viewBox: "0 0 11.767 10.671",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#454f63;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.83,9.412a.532.532,0,1,0,.532.532A.532.532,0,0,0,6.83,9.412Zm5.673.782L8.223,2.749a1.6,1.6,0,0,0-2.786,0L1.184,10.193A1.6,1.6,0,0,0,2.545,12.6h8.571A1.6,1.6,0,0,0,12.5,10.193Zm-.92,1.063a.532.532,0,0,1-.468.271H2.545a.537.537,0,0,1-.468-.8L6.331,3.281a.532.532,0,0,1,.946,0l4.28,7.444a.532.532,0,0,1,.027.542ZM6.83,5.158A.532.532,0,0,0,6.3,5.69V7.817a.532.532,0,1,0,1.063,0V5.69A.532.532,0,0,0,6.83,5.158Z",
    transform: "translate(-0.96 -1.931)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertBlack);
export default __webpack_public_path__ + "static/media/alertBlack.7776f1989e7227bc5eb05d5ed2f5b246.svg";
export { ForwardRef as ReactComponent };